// DashboardPage
import React, { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import "./PageLayout.css";
import "./DashboardPage.css";
import { fetchTotalMaterials } from "../services/api";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import { getFirestore, collection, doc, setDoc, getDocs } from "firebase/firestore";
import { API_BASE_URL } from '../services/api';

/* ─── SVG Icon Components (duotone style, teal-aligned) ─── */

const IconMaterials = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <path d="M12 2L2 7l10 5 10-5-10-5z" opacity=".35" fill="currentColor"/>
    <path d="M2 17l10 5 10-5"/>
    <path d="M2 12l10 5 10-5"/>
  </svg>
);

const IconAnalytics = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <path d="M3 3v18h18" opacity=".15" fill="currentColor"/>
    <path d="M3 3v18h18"/>
    <path d="M7 16l4-4 4 4 5-6"/>
  </svg>
);

const IconCost = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="10" opacity=".15" fill="currentColor"/>
    <path d="M16 8a4 4 0 0 0-8 0c0 2 2 3 4 3.5S16 13 16 15a4 4 0 0 1-8 0"/>
    <line x1="12" y1="6" x2="12" y2="4"/>
    <line x1="12" y1="20" x2="12" y2="18"/>
  </svg>
);

const IconCo2 = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <path d="M12 22c4-4 8-7.5 8-12A8 8 0 0 0 4 10c0 4.5 4 8 8 12z" opacity=".15" fill="currentColor"/>
    <path d="M12 22c4-4 8-7.5 8-12A8 8 0 0 0 4 10c0 4.5 4 8 8 12z"/>
    <path d="M12 12V8"/>
    <path d="M9 10l3-2 3 2"/>
  </svg>
);

const IconBuild = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <rect x="2" y="6" width="20" height="12" rx="2" opacity=".15" fill="currentColor"/>
    <path d="M2 10h20"/>
    <path d="M6 6V4a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v2"/>
    <path d="M12 14v2"/>
    <path d="M8 14v2"/>
    <path d="M16 14v2"/>
  </svg>
);

const IconAccount = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="8" r="4" opacity=".15" fill="currentColor"/>
    <circle cx="12" cy="8" r="4"/>
    <path d="M20 21a8 8 0 1 0-16 0"/>
  </svg>
);

const IconUsers = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" opacity=".15" fill="currentColor"/>
    <circle cx="9" cy="7" r="4"/>
    <path d="M23 21v-2a4 4 0 0 0-3-3.87"/>
    <path d="M16 3.13a4 4 0 0 1 0 7.75"/>
  </svg>
);

const IconSubmissions = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <rect x="3" y="3" width="18" height="18" rx="2" opacity=".15" fill="currentColor"/>
    <path d="M3 9h18"/>
    <path d="M9 3v18"/>
    <path d="M13 13l2 2 4-4"/>
  </svg>
);

const IconCalculator = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <path d="M12 22c4-4 8-7.5 8-12A8 8 0 0 0 4 10c0 4.5 4 8 8 12z" opacity=".15" fill="currentColor"/>
    <path d="M12 22c4-4 8-7.5 8-12A8 8 0 0 0 4 10c0 4.5 4 8 8 12z"/>
    <path d="M12 12V8"/>
    <path d="M9 10l3-2 3 2"/>
  </svg>
);

const IconRequests = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" opacity=".15" fill="currentColor"/>
    <polyline points="14 2 14 8 20 8"/>
    <line x1="16" y1="13" x2="8" y2="13"/>
    <line x1="16" y1="17" x2="8" y2="17"/>
    <polyline points="10 9 9 9 8 9"/>
  </svg>
);

const IconArrow = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M6 4l4 4-4 4"/>
  </svg>
);


/* ─── Sync Progress Modal ─── */

const LOG_LEVELS = {
  INFO:    { color: '#60a5fa', prefix: 'INFO ' },
  SUCCESS: { color: '#34d399', prefix: 'OK   ' },
  WARN:    { color: '#fbbf24', prefix: 'WARN ' },
  ERROR:   { color: '#f87171', prefix: 'ERR  ' },
  STEP:    { color: '#a78bfa', prefix: 'STEP ' },
};

function SyncProgressModal({ isOpen, onClose, logs, status }) {
  const logEndRef = useRef(null);

  // Auto-scroll to bottom as new logs arrive
  useEffect(() => {
    if (logEndRef.current) {
      logEndRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  }, [logs]);

  if (!isOpen) return null;

  const isDone = status === 'success' || status === 'error';

  return (
    <div style={styles.overlay}>
      <div style={styles.modal}>

        {/* ── Title bar ── */}
        <div style={styles.titleBar}>
          <div style={styles.titleDots}>
            <span style={{ ...styles.dot, background: '#ef4444' }} />
            <span style={{ ...styles.dot, background: '#fbbf24' }} />
            <span style={{ ...styles.dot, background: '#34d399' }} />
          </div>
          <span style={styles.titleText}>sync-materials-cache</span>
          <div style={styles.titleRight}>
            {!isDone && <span style={styles.spinner}>⟳</span>}
            {status === 'success' && <span style={{ color: '#34d399', fontSize: 13 }}>✓ Complete</span>}
            {status === 'error'   && <span style={{ color: '#f87171', fontSize: 13 }}>✗ Failed</span>}
          </div>
        </div>

        {/* ── Log output ── */}
        <div style={styles.logArea}>
          {logs.map((entry, i) => {
            const level = LOG_LEVELS[entry.level] || LOG_LEVELS.INFO;
            return (
              <div key={i} style={styles.logLine}>
                <span style={styles.logTime}>{entry.time}</span>
                <span style={{ ...styles.logLevel, color: level.color }}>{level.prefix}</span>
                <span style={{ ...styles.logMsg, color: entry.level === 'ERROR' ? '#f87171' : '#e2e8f0' }}>
                  {entry.message}
                </span>
              </div>
            );
          })}

          {/* Blinking cursor while running */}
          {!isDone && (
            <div style={styles.logLine}>
              <span style={styles.logTime}>{timestamp()}</span>
              <span style={{ ...styles.logLevel, color: '#a78bfa' }}>{'     '}</span>
              <span style={styles.cursor}>█</span>
            </div>
          )}

          <div ref={logEndRef} />
        </div>

        {/* ── Footer ── */}
        <div style={styles.footer}>
          {isDone ? (
            <button style={styles.closeBtn} onClick={onClose}>
              Close
            </button>
          ) : (
            <span style={styles.runningNote}>Running — do not close this window</span>
          )}
        </div>
      </div>
    </div>
  );
}

// Inline styles for the modal (self-contained, no CSS file dependency)
const styles = {
  overlay: {
    position: 'fixed', inset: 0,
    background: 'rgba(0,0,0,0.7)',
    backdropFilter: 'blur(4px)',
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    zIndex: 2000,
  },
  modal: {
    background: '#0d1117',
    border: '1px solid #30363d',
    borderRadius: 12,
    width: 'min(720px, calc(100vw - 32px))',
    maxHeight: 'calc(100vh - 64px)',
    display: 'flex', flexDirection: 'column',
    boxShadow: '0 24px 60px rgba(0,0,0,0.6)',
    overflow: 'hidden',
    animation: 'fadeIn 0.2s ease',
  },
  titleBar: {
    display: 'flex', alignItems: 'center',
    padding: '12px 16px',
    background: '#161b22',
    borderBottom: '1px solid #30363d',
    gap: 10, flexShrink: 0,
  },
  titleDots: { display: 'flex', gap: 6 },
  dot: { width: 12, height: 12, borderRadius: '50%', display: 'inline-block' },
  titleText: {
    flex: 1, textAlign: 'center',
    fontFamily: "'SF Mono', 'Fira Code', monospace",
    fontSize: 12, color: '#8b949e', letterSpacing: '0.04em',
  },
  titleRight: { minWidth: 80, textAlign: 'right', fontFamily: 'monospace', fontSize: 13 },
  spinner: {
    display: 'inline-block',
    color: '#a78bfa', fontSize: 16,
    animation: 'spin 1s linear infinite',
  },
  logArea: {
    flex: 1, overflowY: 'auto',
    padding: '14px 18px',
    fontFamily: "'SF Mono', 'Fira Code', 'Courier New', monospace",
    fontSize: 12.5, lineHeight: 1.7,
    background: '#0d1117',
    minHeight: 260, maxHeight: 420,
  },
  logLine: {
    display: 'flex', gap: 10, alignItems: 'flex-start',
    marginBottom: 2,
  },
  logTime: { color: '#484f58', flexShrink: 0, userSelect: 'none' },
  logLevel: { flexShrink: 0, fontWeight: 700, letterSpacing: '0.03em' },
  logMsg: { wordBreak: 'break-word' },
  cursor: {
    color: '#a78bfa', fontSize: 14, lineHeight: 1,
    animation: 'blink 1s step-end infinite',
  },
  footer: {
    padding: '12px 18px',
    borderTop: '1px solid #30363d',
    background: '#161b22',
    display: 'flex', justifyContent: 'flex-end', alignItems: 'center',
    flexShrink: 0,
  },
  closeBtn: {
    padding: '7px 22px',
    background: '#21262d',
    border: '1px solid #30363d',
    borderRadius: 7,
    color: '#e2e8f0',
    fontFamily: 'monospace', fontSize: 13,
    cursor: 'pointer',
    transition: 'background 0.15s',
  },
  runningNote: {
    fontFamily: 'monospace', fontSize: 12,
    color: '#484f58', fontStyle: 'italic',
  },
};

// Inject keyframe animations once
if (typeof document !== 'undefined' && !document.getElementById('sync-modal-keyframes')) {
  const style = document.createElement('style');
  style.id = 'sync-modal-keyframes';
  style.textContent = `
    @keyframes blink  { 0%,100%{opacity:1} 50%{opacity:0} }
    @keyframes spin   { to{transform:rotate(360deg)} }
    @keyframes fadeIn { from{opacity:0} to{opacity:1} }
  `;
  document.head.appendChild(style);
}

// Helper: HH:MM:SS timestamp
function timestamp() {
  return new Date().toTimeString().slice(0, 8);
}


/* ─── Dashboard Component ─── */

const Dashboard = () => {
  const navigate = useNavigate();
  const [totalMaterials, setTotalMaterials] = useState(0);
  const [activeUsers, setActiveUsers] = useState(0);
  const [totalUsers, setTotalUsers] = useState(0);
  const [recentUsers, setRecentUsers] = useState([]);

  // ── Sync modal state ──────────────────────────────────────────────────
  const [syncModalOpen, setSyncModalOpen]   = useState(false);
  const [syncLogs, setSyncLogs]             = useState([]);
  const [syncStatus, setSyncStatus]         = useState('idle'); // idle | running | success | error
  const [syncing, setSyncing]               = useState(false);

  const appendLog = (level, message) =>
    setSyncLogs((prev) => [...prev, { time: timestamp(), level, message }]);

  // ── Auth + Firestore tracking ─────────────────────────────────────────
  useEffect(() => {
    const auth = getAuth();
    const db = getFirestore();
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      if (user) {
        try {
          const userRef = doc(db, "users", user.uid);
          await setDoc(userRef, { email: user.email, lastLogin: new Date().toISOString() }, { merge: true });
        } catch (error) {
          console.error("❌ Error updating user login time:", error);
        }
      }
    });
    return () => unsubscribe();
  }, []);

  useEffect(() => {
    const loadTotalMaterials = async () => {
      const count = await fetchTotalMaterials();
      setTotalMaterials(count);
      await fetchActiveUsersData();
    };
    loadTotalMaterials();
  }, []);

  const fetchActiveUsersData = async () => {
    const db = getFirestore();
    const usersCollection = collection(db, "users");
    try {
      const snapshot = await getDocs(usersCollection);
      const users = snapshot.docs.map(doc => doc.data());
      setTotalUsers(users.length);
      const now = new Date();
      const activeUsersList = users.filter(user => {
        if (!user.lastLogin) return false;
        const diffInHours = (now - new Date(user.lastLogin)) / (1000 * 60 * 60);
        return diffInHours < 24;
      });
      setActiveUsers(activeUsersList.length);
      setRecentUsers(users.slice(0, 5));
    } catch (error) {
      console.error("❌ Error fetching users:", error);
    }
  };

  // ── Sync handler with step-by-step logging ───────────────────────────
  const handleSyncMaterials = async () => {
  if (syncing) return;
  setSyncLogs([]);
  setSyncStatus('running');
  setSyncModalOpen(true);
  setSyncing(true);

  const log = (level, msg) =>
    setSyncLogs((prev) => [...prev, { time: timestamp(), level, message: msg }]);

  try {
    log('STEP', 'Starting materials cache sync…');
    const auth = getAuth();
    const token = await auth.currentUser.getIdToken();
    log('SUCCESS', 'Admin token acquired.');

    log('STEP', 'Dispatching sync request…');
    const kickoffRes = await fetch(`${API_BASE_URL}/admin/sync-materials-cache`, {
      method: 'POST',
      headers: { Authorization: `Bearer ${token}` },
    });
    const kickoff = await kickoffRes.json();

    if (!kickoffRes.ok || !kickoff.jobId) {
      log('ERROR', kickoff.error || 'Failed to start sync job.');
      setSyncStatus('error');
      return;
    }

    log('INFO', `Job started (ID: ${kickoff.jobId}). Waiting for sync service…`);

    // Poll until done
    const pollInterval = 3000; // 3s
    const maxWait = 150_000;   // 2.5 min
    const started = Date.now();

    await new Promise((resolve) => {
      const poll = setInterval(async () => {
        try {
          const statusRes = await fetch(`${API_BASE_URL}/admin/sync-status/${kickoff.jobId}`, {
            headers: { Authorization: `Bearer ${token}` },
          });
          const statusData = await statusRes.json();

          if (statusData.status === 'success') {
            clearInterval(poll);
            log('SUCCESS', statusData.message || 'Sync completed successfully.');
            log('SUCCESS', '✓ All done — materials cache is being refreshed.');
            setSyncStatus('success');
            resolve();
          } else if (statusData.status === 'error') {
            clearInterval(poll);
            log('ERROR', statusData.message || 'Sync failed.');
            if (statusData.detail) log('ERROR', `Detail: ${statusData.detail}`);
            setSyncStatus('error');
            resolve();
          } else if (Date.now() - started > maxWait) {
            clearInterval(poll);
            log('ERROR', 'Timed out waiting for sync to complete.');
            setSyncStatus('error');
            resolve();
          } else {
            log('INFO', 'Still running…');
          }
        } catch (e) {
          clearInterval(poll);
          log('ERROR', `Polling error: ${e.message}`);
          setSyncStatus('error');
          resolve();
        }
      }, pollInterval);
    });

  } catch (e) {
    log('ERROR', `Unexpected error: ${e.message}`);
    setSyncStatus('error');
  } finally {
    setSyncing(false);
  }
};

  // ── Helpers ───────────────────────────────────────────────────────────
  const delay = (ms) => new Promise((r) => setTimeout(r, ms));

  const currentDate  = new Date();
  const formattedDate = currentDate.toLocaleDateString("en-US", { weekday:"long", year:"numeric", month:"long", day:"numeric" });
  const formattedTime = currentDate.toLocaleTimeString("en-US", { hour:"2-digit", minute:"2-digit" });

  const getInitials = (email) => (!email ? '?' : email.split('@')[0].substring(0, 2));
  const isOnline    = (lastLogin) => !!lastLogin && (new Date() - new Date(lastLogin)) / (1000 * 60 * 60) < 1;
  const timeAgo     = (lastLogin) => {
    if (!lastLogin) return 'Unknown';
    const diff = (new Date() - new Date(lastLogin)) / 1000;
    if (diff < 60)    return 'Just now';
    if (diff < 3600)  return `${Math.floor(diff / 60)}m ago`;
    if (diff < 86400) return `${Math.floor(diff / 3600)}h ago`;
    return `${Math.floor(diff / 86400)}d ago`;
  };

  // ── Card section data ─────────────────────────────────────────────────
  const sections = [
    {
      title: 'Materials & Builder',
      icon: '🧱', iconClass: 'build', count: '4 tools',
      cards: [
        { label: 'Material Library',   desc: 'Browse materials and their properties',      path: '/categories',   Icon: IconMaterials, color: 'teal' },
        { label: 'Cost',               desc: 'Cost data for composites and materials',     path: '/supply-rates', Icon: IconCost,      color: 'emerald' },
        { label: 'CO\u2082 & Weight',  desc: 'Carbon and weight metrics for materials',    path: '/co2',          Icon: IconCo2,       color: 'sky' },
        { label: 'Build New Material', desc: 'Create custom composite material build-ups', path: '/newmaterial',  Icon: IconBuild,     color: 'amber' },
        { label: 'Calculators',  desc: 'Choose from a list of calculators to help with quantification',     path: '/user/calculator',       Icon: IconCalculator, color: 'sky' },

      ],
    },
    {
      title: 'Accounts & Users',
      icon: '👥', iconClass: 'users', count: '3 tools',
      cards: [
        { label: 'Accounts',        desc: 'Manage your account details',              path: '/account',               Icon: IconAccount,   color: 'indigo' },
        { label: 'User Management', desc: 'Approve and inspect users and suppliers',  path: '/admin/user-management', Icon: IconUsers,     color: 'violet' },
        { label: 'User Analytics',  desc: 'Login activity, requests, and user insights', path: '/admin/user-analytics', Icon: IconAnalytics, color: 'emerald' },
      ],
    },
    {
      title: 'Requests & Submissions',
      icon: '📋', iconClass: 'requests', count: '2 tools',
      cards: [
        { label: 'Product Submissions', desc: 'Product submissions from users and suppliers', path: '/admin/material-submissions', Icon: IconSubmissions, color: 'rose' },
        { label: 'Material Requests',   desc: 'Composite material build-up requests',         path: '/admin/composite-requests',   Icon: IconRequests,   color: 'slate' },
      ],
    },
  ];

  // ── Render ────────────────────────────────────────────────────────────
  return (
    <div className="neo-dashboard">

      {/* ─── Card Sections ─── */}
      {sections.map((section) => (
        <section className="nd-section" key={section.title}>
          <div className="nd-section__header">
            <div className={`nd-section__icon nd-section__icon--${section.iconClass}`}>{section.icon}</div>
            <h2 className="nd-section__title">{section.title}</h2>
            <span className="nd-section__count">{section.count}</span>
          </div>
          <div className="nd-grid">
            {section.cards.map((card) => (
              <div className="nd-card" key={card.path} onClick={() => navigate(card.path)}>
                <div className={`nd-card__icon nd-card__icon--${card.color}`}><card.Icon /></div>
                <div className="nd-card__body"><h3>{card.label}</h3><p>{card.desc}</p></div>
                <span className="nd-card__arrow"><IconArrow /></span>
              </div>
            ))}
          </div>
        </section>
      ))}

      {/* ─── Bottom panels ─── */}
      <div className="nd-bottom-row">

        {/* Stats overview */}
        <div className="nd-stats-panel">
          <div className="nd-stats-panel__header">
            <div className="nd-stats-panel__icon">📊</div>
            <h3 className="nd-stats-panel__title">Platform Overview</h3>
          </div>
          <div className="nd-stats-grid">
            <div className="nd-stat-block">
              <div className="nd-stat-block__value">{totalMaterials.toLocaleString()}</div>
              <div className="nd-stat-block__label">Materials</div>
              <div className="nd-stat-block__emoji"><span>🪨</span><span>🌲</span><span>🔩</span></div>
            </div>
            <div className="nd-stat-block">
              <div className="nd-stat-block__value">{totalUsers}</div>
              <div className="nd-stat-block__label">Total Users</div>
            </div>
            <div className="nd-stat-block">
              <div className="nd-stat-block__value">{activeUsers}</div>
              <div className="nd-stat-block__label">Active (24h)</div>
            </div>
          </div>

          <div className="nd-sync-row">
            <button
              className={`nd-sync-btn ${syncing ? 'nd-sync-btn--loading' : ''}`}
              onClick={handleSyncMaterials}
              disabled={syncing}
            >
              {syncing ? '⏳ Syncing…' : '🔄 Sync Materials Cache'}
            </button>
            {/* Re-open modal to see last run */}
            {!syncing && syncStatus !== 'idle' && (
              <button
                style={{
                  marginLeft: 10, padding: '6px 12px',
                  background: 'transparent',
                  border: '1px solid #30363d',
                  borderRadius: 6, cursor: 'pointer',
                  fontSize: 12, color: '#6b7280',
                  fontFamily: 'monospace',
                }}
                onClick={() => setSyncModalOpen(true)}
                title="View last sync log"
              >
                📋 Last Log
              </button>
            )}
          </div>
        </div>

        {/* Recent logins */}
        <div className="nd-logins-panel">
          <div className="nd-logins-panel__header">
            <div className="nd-logins-panel__icon">🕒</div>
            <h3 className="nd-logins-panel__title">Recent Logins</h3>
            <span className="nd-logins-panel__badge">{activeUsers} online</span>
          </div>
          {recentUsers.length > 0 ? (
            <ul className="nd-login-list">
              {recentUsers.map((user, index) => (
                <li className="nd-login-item" key={index}>
                  <div className="nd-login-avatar">{getInitials(user.email)}</div>
                  <div className="nd-login-info">
                    <div className="nd-login-email">{user.email}</div>
                    <div className="nd-login-time">{timeAgo(user.lastLogin)}</div>
                  </div>
                  <div className={`nd-login-dot ${isOnline(user.lastLogin) ? 'nd-login-dot--online' : 'nd-login-dot--offline'}`} />
                </li>
              ))}
            </ul>
          ) : (
            <div className="nd-logins-empty">No recent logins</div>
          )}
        </div>
      </div>

      {/* ─── Sync Progress Modal ─── */}
      <SyncProgressModal
        isOpen={syncModalOpen}
        onClose={() => setSyncModalOpen(false)}
        logs={syncLogs}
        status={syncStatus}
      />
    </div>
  );
};

export default Dashboard;